import { render, staticRenderFns } from "./DTCEdit.vue?vue&type=template&id=08ade99c&"
import script from "./DTCEdit.vue?vue&type=script&lang=js&"
export * from "./DTCEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports